import { JournalPage } from "components/frontComponents/journalPage/JournalPage";
import gsap from "gsap";
import styles from "./styles.module.scss";
import Left from "assets/images/about/about_left.png";
import Right from "assets/images/about/about_right.png";
import Terra from "assets/images/about/terra_mini1.png";
import Osteon from "assets/images/about/osteon_mini.png";
import Betweener from "assets/images/about/betweener_mini1.png";
import Mission from "assets/images/about/mission_mini1.png";
import { useEffect, useRef } from "react";
import { ScrollPageProps } from "../FirstPage";
import { RouterPathEnum } from "shared/enums/commonEnums";
import { useNavigate } from "react-router-dom";
import Yellow1440 from "assets/images/about/yellow1440.png";
import Yellow768 from "assets/images/about/yellow768.png";

import Red1440 from "assets/images/about/red1440.png";
import Red768 from "assets/images/about/red768.png";
import Dark1440 from "assets/images/about/dark1440.png";
import Dark768 from "assets/images/about/dark768.png";

export const About: React.FC<ScrollPageProps> = ({
  scrollToRef,
  mainRef,
  featuresRef,
  contactsRef,
  aboutRef,
  activeSection,
}) => {
  const terraRef = useRef(null);
  const osteonRef = useRef(null);
  const betweenerRef = useRef(null);
  const missionRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    gsap.to(
      [
        terraRef.current,
        osteonRef.current,
        betweenerRef.current,
        missionRef.current,
      ],
      {
        duration: 2,
        scale: 1.2,
        ease: "power2.inOut",
        repeat: -1,
        yoyo: true,
      }
    );
  }, []);

  return (
    <div className={styles.about} id="about">
      <JournalPage
        scrollToRef={scrollToRef}
        mainRef={mainRef}
        featuresRef={featuresRef}
        contactsRef={contactsRef}
        aboutRef={aboutRef}
        activeSection={activeSection}
        leftContent={
          <div className={styles.containerLeft}>
            {/* <img
              srcSet={`
          ${Left768} 768w,
          ${Left1024} 1024w,
          ${Left1440} 1440w,
           ${Left} 1920w,
        `}
              sizes="50vw"
              src={Left768}
              alt=""
              loading="lazy"
            /> */}
            {/* <picture>
              <source media="(min-width: 1920px)" srcSet={Left} />
              <source media="(min-width: 1000px)" srcSet={Left1440} />
              
              <img src={Left768} alt="" loading="lazy" />
            </picture> */}
            <div className={styles.photoholder}>
              <img
                src={Left}
                alt=""
                loading="lazy"
                className={styles.photoright}
              />
            </div>
            <div className={styles.bubbleHolder}>
              <img
                src={Terra}
                className={styles.terra}
                ref={terraRef}
                onClick={() => navigate(RouterPathEnum.Explanation)}
                alt=""
                loading="lazy"
              />
            </div>

            {/* <picture>
              <source media="(min-width: 1920px)" srcSet={Terra} />
              <source media="(min-width: 1000px)" srcSet={Pink1440} />
              <img
                src={Pink768}
                className={styles.terra}
                ref={terraRef}
                onClick={() => navigate(RouterPathEnum.Explanation)}
                alt=""
                loading="lazy"
              />
            </picture> */}
            <picture>
              <source media="(min-width: 1920px)" srcSet={Osteon} />
              <source media="(min-width:1000px)" srcSet={Yellow1440} />
              <img
                src={Yellow768}
                className={styles.osteon}
                ref={osteonRef}
                onClick={() => navigate(RouterPathEnum.Explanation)}
                alt=""
                loading="lazy"
              />
            </picture>
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            {/* <img src={Right} alt="" /> */}
            {/* <picture>
              <source media="(min-width: 1920px)" srcSet={Right} />
              <source media="(min-width: 1000px)" srcSet={Right1440} />
              <img src={Right768} alt="" loading="lazy" />
            </picture> */}
            <div className={styles.photoholder}>
              <img
                src={Right}
                alt=""
                loading="lazy"
                className={styles.photoright}
              />
            </div>
            <picture>
              <source media="(min-width: 1920px)" srcSet={Betweener} />
              <source media="(min-width: 1000px)" srcSet={Dark1440} />
              <img
                src={Dark768}
                className={styles.betweener}
                ref={betweenerRef}
                onClick={() => navigate(RouterPathEnum.Explanation)}
                alt=""
                loading="lazy"
              />
            </picture>

            <picture>
              <source media="(min-width: 1920px)" srcSet={Mission} />
              <source media="(min-width: 1000px)" srcSet={Red1440} />
              <img
                src={Red768}
                className={styles.mission}
                ref={missionRef}
                onClick={() => navigate(RouterPathEnum.Explanation)}
                alt=""
                loading="lazy"
              />
            </picture>
            {/* <img
              src={Betweener}
              className={styles.betweener}
              ref={betweenerRef}
              onClick={() => navigate(RouterPathEnum.Explanation)}
              alt=""
            />
            <img
              src={Mission}
              className={styles.mission}
              ref={missionRef}
              onClick={() => navigate(RouterPathEnum.Explanation)}
              alt=""
            /> */}
          </div>
        }
      />
    </div>
  );
};
